import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { DetailsValues } from '../state';

import { MaterialSymbol } from '@/components/MaterialSymbol';
import { MonoText } from '@/components/ui';

/**
 * Resource planning, in the When card since 3 Nov (decision 18; it was half of
 * Where it belongs), with no heading of its own (Mette, 3 Nov): in the resource
 * planner or not, and how likely the project is to go ahead. The likelihood shows only before go-live, which
 * every Draft project is (decision 2).
 */
export type ResourcePlanningFactsProps = {
  values: Pick<DetailsValues, 'includeInResourcePlanning' | 'likelihoodPct'>;
};

export const ResourcePlanningFacts = ({ values }: ResourcePlanningFactsProps) => {
  const { t } = useTranslation('pmDetails');
  return (
    <Stack sx={{ gap: 1.5 }}>
      <Stack
        direction="row"
        sx={{ alignItems: 'center', gap: 0.75 }}
        data-automation-id="details-when-planner"
      >
        <Typography variant="bodyRegular" component="span">
          {values.includeInResourcePlanning ? t('when.InPlanner') : t('when.NotInPlanner')}
        </Typography>
        {values.includeInResourcePlanning ? (
          <MaterialSymbol name="check" size={18} color="var(--color-success-80)" />
        ) : null}
      </Stack>
      <Stack sx={{ gap: 0.25 }} data-automation-id="details-when-likelihood">
        <Stack direction="row" sx={{ alignItems: 'baseline', gap: 0.75 }}>
          <Typography variant="bodyRegular" component="span">
            {t('when.Likely')}
          </Typography>
          <MonoText>{`${String(values.likelihoodPct)}%`}</MonoText>
        </Stack>
        <Typography variant="label" component="span" sx={{ color: 'var(--color-fog-80)' }}>
          {t('when.LikelyHelp')}
        </Typography>
      </Stack>
    </Stack>
  );
};
